import React from "react";
import {observer} from "mobx-react";
import {useServices} from "../../../../hooks/use-services.hook";
import {DepartingFlightSelectionPageContent} from "../../../booking-flow/fare-selection/departure/departing-flight-selection-page-content.component";
import {BookingFlowPage} from "../../../booking-flow/booking-flow.page";

const ManageMyBookingSelectNewDepartingFlightPageContent: React.FC = observer(() => {
    return (
        <DepartingFlightSelectionPageContent allowBundleSelection={false}/>
    );
});

export const ManageMyBookingSelectNewDepartingFlightPage: React.FC = observer(() => {
    const services = useServices();

    return (
        <BookingFlowPage headerOptions={{
                            title: services.language.translate('Departure Flight')
                         }}
                         contentOptions={{
                             renderContent: () => <ManageMyBookingSelectNewDepartingFlightPageContent/>
                         }}
                         shoppingCartOptions={{
                             showPromotionCode: false
                         }}
        />
    );
});
